import { useGtm } from '@gtm-support/vue-gtm'

import { buildGtmLogger, getGtmConfig } from './plugin.utils'

export class GTM {
  constructor() {
    this.log = buildGtmLogger()

    this.gtm = null
  }

  get isInit() {
    return Boolean(this.gtm)
  }

  async create(id) {
    try {
      if (this.isInit) {
        this.log('Модуль уже проинициализирован', this.gtm.id)

        return false
      }

      this.gtm = useGtm()
      this.gtm.id = id || getGtmConfig().id
      this.gtm.enable(true)

      this.log('Инициализация прошла успешно', id)

      return this.gtm
    } catch (error) {
      this.log('Ошибка инициализации', error)
      console.error(error)
    }
  }

  push(payload) {
    this.log('push', payload)

    if (!this.isInit) {
      return undefined
    }

    return this.gtm.push(payload)
  }
}
